import { Component, OnInit, ViewChild } from '@angular/core';
import { BusinessEntityResource } from 'src/app/interfaces/business-entity-resource';
import { BusinessEntityService } from 'src/app/services/business-entity.service';
import { MatTableDataSource } from '@angular/material/table';
import { EnvironmentService } from 'src/app/services/environment.service';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { OverlayService } from 'src/app/services/overlay.service';
import { ChannelType } from 'src/app/enums/channel-type.enum';
import { TooltipPosition } from '@angular/material/tooltip';
import { ActivatedRoute, Router } from '@angular/router';
import { PageEvent } from '@angular/material/paginator';
/**
 * The Options used for sorting
 */
interface SortOption {
  /**
   * The Value of the Filteroption
   */
  value: string;
  /**
   * The viewValue (visible to the User) of the Filteroption
   */
  viewValue: string;
  /**
   * Is the  Filteroption disabled
   */
  state?: boolean;
}
@Component({
  selector: 'app-businessentity',
  templateUrl: './businessentity.component.html',
  styleUrls: ['./businessentity.component.scss']
})
export class BusinessentityComponent implements OnInit {
  postoolTip: TooltipPosition = "above";
  filterForm: UntypedFormGroup;
  public searchString = '';
  displayedColumns = ['Nummer', 'Logo', 'name', 'Adresse', 'Kontaktdaten', 'state', 'menu']; //'Kontaktdaten',
  dataSource: MatTableDataSource<BusinessEntityResource>;
  allBusinessEntityResources: Array<BusinessEntityResource>;
  page;
  pageData = {
    pageIndex: 0,
    pageSize: 12
  }


  public sortOptionsState: SortOption[] = [
    { value: "ACTIVE", viewValue: "Aktiv" },
    { value: "DISABLED", viewValue: "Archiviert" },
    { value: "NEW", viewValue: "Erstellt" },
    { value: "DELETED", viewValue: "Gelöscht" },
    { value: "PENDING", viewValue: "Ausstehend" }
  ];


  constructor(
    private businessEntityService: BusinessEntityService,
    private environment: EnvironmentService,
    private fb: UntypedFormBuilder,
    private overlayService: OverlayService,
    private router: Router,
    private route: ActivatedRoute) {
    this.filterForm = this.fb.group({
      searchTerm: ['', []],
      filterState: [],
    })
  }


  ngAfterViewInit() {

  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.filterForm.markAllAsTouched();
      this.filterForm.patchValue({
        searchTerm: params?.searchTerm,
        filterState: params?.filterState?.split(','),
      })
      if (params?.page) {
        this.pageData.pageIndex = params?.page;
      }
      if (params?.size) {
        this.pageData.pageSize = params?.size;
      }
    })


    this.businessEntityService.getAllBuissnesEntitiesWithFilter(this.pageData.pageIndex, this.pageData.pageSize, this.filterForm.value.filterState, this.filterForm.value.searchTerm).subscribe((partners: any) => {
      this.dataSource = new MatTableDataSource(partners.content);
      this.allBusinessEntityResources = partners.content;
      this.page = partners.page;
    })
  }

  downloadReservationList() {
    this.businessEntityService.getPartnerList().subscribe(val=>{
      var a = document.createElement("a");
      const contentType = 'application/vnd.ms-excel'; 
      const blob = new Blob([val], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = "Aktionspartnerliste";
      a.click();
      window.URL.revokeObjectURL(url);
    })
  }


  openStateChangeBottomSheet(event) {
    this.overlayService.openBottomSheetBusinessEntityResourceState(event).subscribe(value => {
    })
  }

  delete(businessEntityResource) {
    businessEntityResource.state = "DELETED"
    this.businessEntityService.changeState(businessEntityResource).subscribe((value: BusinessEntityResource) => {
      if (value.publicId != null) {
        this.overlayService.openSnackBar('Aktion erfolgreich gelöscht!');
      }
    })
  }

  filterBusinessentity() {
    this.router.navigate([],
      {
        relativeTo: this.route,
        queryParams: {
          searchTerm: this.filterForm.value?.searchTerm,
          filterState: this.filterForm.value?.filterState?.join(),
        },
        queryParamsHandling: 'merge'
      }).then(() => {
        this.businessEntityService.getAllBuissnesEntitiesWithFilter(this.pageData.pageIndex, this.pageData.pageSize, this.filterForm.value.filterState, this.filterForm.value.searchTerm).subscribe((partners: any) => {
          this.dataSource = new MatTableDataSource(partners.content);
          this.page = partners.page;
          this.allBusinessEntityResources = partners.content;
        })
      })
  }

  goToPartner(row) {
    this.router.navigate(['caseworker/businessentity/edit', row.publicId])
  }


  loadPage(event?: PageEvent) {
    this.pageData.pageIndex = event.pageIndex;
    this.pageData.pageSize = event.pageSize;
    this.router.navigate([],
      {
        relativeTo: this.route,
        queryParams: {
          page: event.pageIndex,
          size: event.pageSize,
        },
        queryParamsHandling: 'merge'
      }).then(() => {
        return this.search(event.pageIndex, event.pageSize);
      })
  }

  search(pageIndex, pageSize) {
    this.businessEntityService.getAllBuissnesEntitiesWithFilter(pageIndex, pageSize, this.filterForm.value.filterState, this.filterForm.value.searchTerm).subscribe((partners: any) => {
      this.dataSource = new MatTableDataSource(partners.content);
      this.page = partners.page;
      this.allBusinessEntityResources = partners.content;
    })
  }


  resetFitler() {
    this.filterForm.reset()
    this.router.navigate([],
      {
        relativeTo: this.route,
        queryParams: {
          searchTerm: this.filterForm.value?.searchTerm,
          filterState: this.filterForm.value?.filterState?.join()
        },
        queryParamsHandling: 'merge'
      }).then(() => {
        this.filterBusinessentity();
      })
  }
}